<template>
  <svg width="52" height="52" viewBox="0 0 52 52" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M35.529 16.471a2.568 2.568 0 0 0-3.647 0L26 22.38l-5.882-5.908a2.579 2.579 0 0 0-3.647 3.647L22.38 26l-5.908 5.882a2.568 2.568 0 0 0 0 3.647 2.568 2.568 0 0 0 3.647 0L26 29.62l5.882 5.908a2.568 2.568 0 0 0 3.647 0 2.568 2.568 0 0 0 0-3.647L29.62 26l5.908-5.882a2.568 2.568 0 0 0 0-3.647zm8.63-8.63A25.684 25.684 0 1 0 7.841 44.159 25.684 25.684 0 1 0 44.158 7.842zm-3.622 32.696A20.547 20.547 0 1 1 46.547 26a20.42 20.42 0 0 1-6.01 14.537z"
      fill="currentColor"
      fill-rule="nonzero"
    />
  </svg>
</template>
